import { Button, Drawer, Form, Input, Space, Upload } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
// import { NotificationInfo, UserInfo } from "../../../../context";

const AddBanner = ({ open, close, setLoading, rerun }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [fileList, setFileList] = useState([{}]);

  const handleChange = (info) => {
    // console.log(info);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    // console.log("fileList", fileList);
    setFileList(fileList);
  };

  const handleCreateBanner = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("image", values.file.file);

    // for (const name in values) {
    //   formdata.append(name, values[name]);
    // }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-banner", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Created new banner successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Banner"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-banner"
        initialValues={{ remember: true }}
        onFinish={handleCreateBanner}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="file"
            rules={[
              {
                required: true,
                message: "Banner required",
              },
            ]}
          >
            <Upload
              beforeUpload={({ fileList: newFileList }) => {
                // setFileList(newFileList);
                return false;
              }}
              onChange={handleChange}
              multiple={false}
              listType="picture-card"
              maxCount={1}
              // defaultFileList={[]}
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={fileList}
              // previewFile={false}
            >
              {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
              Upload
            </Upload>
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddBanner;
